import { Image, Link, Text } from '@weareconceptstudio/core';

//* Styles
import BlogItemStyle from './style';

//* Helpers
import { config } from '@/helpers';

const BlogItem = ({ featured_title, slug, featured_image, date }) => {
	return (
		<BlogItemStyle className='blog-item-wrapper'>
			<Link
				url={`${config.routes.blog.path}${slug}`}
				className='blog-item-link-wrapper'
			>
				<div className='blog-item-inner-wrapper'>
					<div className='blog-item-image-wrapper'>
						<Image
							src={featured_image.src}
							alt={featured_image.alt}
						/>
					</div>

					<div className='blog-item-info-wrapper'>
						<div className='blog-item-info-inner-wrapper'>
							<Text className='p2 green-1000 font-fss-regular date-text'>{date || 'DATE'}</Text>

							<Text className='p1 green-1000 font-larken-regular banner-text'>{featured_title}</Text>
						</div>
					</div>
				</div>
			</Link>
		</BlogItemStyle>
	);
};

export default BlogItem;
